// extracted by mini-css-extract-plugin
export default {"root":"VgCsCfbVf2vdS_sWoPw5","placeHolderShimmer":"bwQt81fTnJPSWE0hIOaG"};